import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import {CopyToClipboard} from 'react-copy-to-clipboard'

import snackbarActions from 'store/modules/snackbar'
import authActions from 'store/modules/auth'
import authSelectors from 'store/selectors/auth'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(5),
  },
  dialogPaper: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
  button: {
    marginRight: theme.spacing(2),
  },
  tokenWrapper: {
    width: '100%',
    backgroundColor: "#002b36",
    color: '#fdf6e3',
    border: '1px solid #000',
    overflowX: 'auto',
  },
  tokenPre: {
    paddingLeft: theme.spacing(2),
  },
  tokenCode: {
  },
  string: {
    color: "#b58900",
  },
  comment: {
    color: "#839496",
  },
  key: {
    color: "#859900",
  }
}))

const AccessToken = ({

}) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const accessToken = useSelector(authSelectors.accessToken)
  const onCopyToClipboard = () => dispatch(snackbarActions.setSuccess('Token copied to clipboard'))
  
  useEffect(() => {
    dispatch(authActions.getAccessToken())
  }, [])
  if(!accessToken) return null
  return (
    <div className={ classes.root }>
      <Paper className={ classes.paper }>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom>
              Get Testfaster CLI and log in
            </Typography>
            <p>Currently supported architectures for the CLI: Linux x86_64 and arm64, macOS x86_64. On Windows, please use WSL.</p>
          </Grid>
          <Grid item xs={12}>
            <div className={ classes.tokenWrapper }>
              <pre className={ classes.tokenPre }><code className={ classes.tokenCode }>
                <span className={ classes.string }>sudo curl -sSL -o</span> /usr/local/bin/testctl <span className={ classes.string }>\</span><br/>
                &nbsp;&nbsp;&nbsp;&nbsp;https://storage.googleapis.com/get-faster-ci/$(uname -sm |sed 's/ /-/')/testctl<br/>
                <span className={ classes.string }>sudo chmod +x</span> /usr/local/bin/testctl<br/>
                <span className={ classes.string }>testctl login --token \</span><br/>
                &nbsp;&nbsp;&nbsp;&nbsp;{ accessToken ? accessToken.token : '' }
              </code></pre>
            </div>
          </Grid>
          <Grid item xs={12}>
            <CopyToClipboard
              text={`sudo curl -sSL -o /usr/local/bin/testctl https://storage.googleapis.com/get-faster-ci/$(uname -sm |sed 's/ /-/')/testctl
sudo chmod +x /usr/local/bin/testctl
testctl login --token ${ accessToken ? accessToken.token : '' }`}
              onCopy={ onCopyToClipboard }
            >
              <Button
                type="button"
                color="primary"
                variant="contained"
              >
                Copy to clipboard
              </Button>
            </CopyToClipboard>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom>
              <br/>Demo config
            </Typography>
          <Grid item xs={12}>
            <div className={ classes.tokenWrapper }>
              <pre className={ classes.tokenPre }><code className={ classes.tokenCode }>
                <span className={ classes.string }>mkdir -p</span> testfaster-demo<br/>
                <span className={ classes.string }>cd</span> testfaster-demo<br/><br/>
                <span className={ classes.string }>cat &lt;&lt;</span>EOF<span className={ classes.string }> &gt; </span>.testfaster.yml<br/>
                <span className={ classes.key }>name</span>: Myproject<br/>
                <span className={ classes.key }>base</span>:<br/>
                &nbsp;&nbsp;<span className={ classes.key }>kernel_image</span>: quay.io/testfaster/ignite-kernel<br/>
                &nbsp;&nbsp;<span className={ classes.key }>os_dockerfile</span>: |-<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className={ classes.comment }># This dockerfile defines the base disk image for your VMs</span><br/>
                &nbsp;&nbsp;&nbsp;&nbsp;FROM quay.io/testfaster/kube-ubuntu<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;RUN touch /root/hello-world.txt<br/>
                &nbsp;&nbsp;<span className={ classes.key }>docker_bake_script</span>: |-<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className={ classes.comment }># Do things that cache docker images for faster builds,</span><br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className={ classes.comment }># like building a prior version of your software.</span><br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className={ classes.comment }># Docker buildkit cache is preserved!</span><br/>
                &nbsp;&nbsp;&nbsp;&nbsp;#!/bin/bash<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;set -euo pipefail<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;docker pull busybox:1.32.0<br/>
                &nbsp;&nbsp;<span className={ classes.key }>preload_docker_images</span>:<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className={ classes.comment }># You can also pull docker images like this. Always use</span><br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className={ classes.comment }># immutable tags for reproducibility!</span><br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className={ classes.string }>-</span> nginx:1.19.5<br/>
                &nbsp;&nbsp;<span className={ classes.key }>prewarm_script</span>: |-<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className={ classes.comment }># This gets run after each individual VM starts up, so</span><br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className={ classes.comment }># start services you need in your tests here and they'll be</span><br/>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className={ classes.comment }># already running when you testctl get</span><br/>
                &nbsp;&nbsp;&nbsp;&nbsp;#!/bin/bash<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;set -euo pipefail<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;docker run -d nginx:1.19.5<br/>
                &nbsp;&nbsp;<span className={ classes.comment }># If you specify a Kubernetes version, you get Kubernetes</span><br/>
                &nbsp;&nbsp;<span className={ classes.key }>kubernetes_version</span>: v1.18.3<br/>
                <span className={ classes.key }>runtime</span>:<br/>
                &nbsp;&nbsp;<span className={ classes.key }>cpus</span>: 4<br/>
                &nbsp;&nbsp;<span className={ classes.key }>memory</span>: 8GB<br/>
                &nbsp;&nbsp;<span className={ classes.key }>disk</span>: 50GB<br/>
                <span className={ classes.comment }># How many ready VMs to keep running for instant testctl get</span><br/>
                <span className={ classes.key }>prewarm_pool_size</span>: 1<br/>
                <span className={ classes.comment }># Upper bound for pool size, e.g. to keep memory usage sensible</span><br/>
                <span className={ classes.key }>max_pool_size</span>: 2<br/>
                <span className={ classes.comment }># Timeout VMs after this long. Set to "" if you want to use</span><br/>
                <span className={ classes.comment }># the VMs for long running development purposes rather than</span><br/>
                <span className={ classes.comment }># short-lived CI.</span><br/>
                <span className={ classes.key }>default_lease_timeout</span>: 1h<br/>
                EOF<br/><br/>
                <span className={ classes.comment }># Submit the pool config and pop a VM from the pool</span><br/>
                <span className={ classes.string }>testctl get</span><br/>
              </code></pre>
            </div>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom>
              <br/>Access Token
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <div className={ classes.tokenWrapper }>
              <pre className={ classes.tokenPre }><code className={ classes.tokenCode }>{ accessToken ? accessToken.token : '' }</code></pre>
            </div>
          </Grid>
          </Grid>
          <Grid item xs={12}>
            <CopyToClipboard
              text={ accessToken ? accessToken.token : '' }
              onCopy={ onCopyToClipboard }
            >
              <Button
                type="button"
                color="primary"
                variant="contained"
              >
                Copy to clipboard
              </Button>
            </CopyToClipboard>
          </Grid>
        </Grid>
      </Paper>
    </div>
  )
}

export default AccessToken
